import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { AgGridModule } from "@ag-grid-community/angular";

import { ComponentsModule } from "src/app/components/components.module";

import { AngularMaterialModule } from "../angular-material/angular-material.module";
import { DecimalNumberDirectiveModule } from "../../directives/decimal-number";

import { SkuDetailRoutingModule } from "./detail-routing.module";

import { ProductDetailComponent } from './product-detail/product-detail.component';
import { SkuDetailComponent } from './sku-detail/sku-detail.component';
import {SingleSkuPriceSettingsComponent} from './presentational/single-sku-price-settings/single-sku-price-settings.component';
import { SkuCompetitionGridComponent } from "./presentational/sku-competition-grid/sku-competition-grid.component";
import { SkuFbaHistoryGridComponent } from "./presentational/sku-fba-history-grid/sku-fba-history-grid.component";
import { SkuHistoryGridComponent } from "./presentational/sku-history-grid/sku-history-grid.component";
import { SkuInfoComponent } from "./presentational/sku-info/sku-info.component";
import { SkuItemStockGridComponent } from "./presentational/sku-item-stock-grid/sku-item-stock-grid.component";
import { SkuMappingEditComponent } from "./presentational/sku-mapping-edit/sku-mapping-edit.component";
import { SkuMappingComponent } from "./presentational/sku-mapping/sku-mapping.component";
import { SkuPriceRangeGridComponent } from "./presentational/sku-price-range-grid/sku-price-range-grid.component";
import { SkuSettingsComponent } from "./presentational/sku-settings/sku-settings.component";
import { SyncHistoryComponent } from "./presentational/sync-history/sync-history.component";

import { SyncDisablePopupComponent } from './presentational/sync-disable-popup/sync-disable-popup.component';
import { FbmProductdetailsComponent } from './presentational/fbm-productdetails/fbm-productdetails.component';
import { FbmSkudetailsComponent } from './presentational/fbm-skudetails/fbm-skudetails.component';
import { FbmFinancialsDetailsComponent } from './presentational/fbm-financials-details/fbm-financials-details.component';
import { CalculatePriceComponent } from './presentational/calculate-price/calculate-price.component';
import { PriceBreakdownComponent } from "../priceyard/price-breakdown/price-breakdown.component";

@NgModule({
  declarations: [
    SkuInfoComponent,
    SkuPriceRangeGridComponent,
    SkuHistoryGridComponent,
    SkuCompetitionGridComponent,
    SkuSettingsComponent,
    SingleSkuPriceSettingsComponent,
    SkuItemStockGridComponent,
    SkuFbaHistoryGridComponent,
    SkuMappingComponent,
    SkuMappingEditComponent,
    SkuDetailComponent,
    ProductDetailComponent,
    SyncHistoryComponent,
    SyncDisablePopupComponent,
    FbmProductdetailsComponent,
    FbmSkudetailsComponent,
    FbmFinancialsDetailsComponent,
    CalculatePriceComponent,
    PriceBreakdownComponent,
  ],
  imports: [
    CommonModule,
    SkuDetailRoutingModule,
    AgGridModule,
    ReactiveFormsModule,
    FormsModule,
    ComponentsModule,
    AngularMaterialModule,
    DecimalNumberDirectiveModule,
  ],
  exports: [
    SkuInfoComponent,
    SkuPriceRangeGridComponent,
    SkuHistoryGridComponent,
    SkuCompetitionGridComponent,
    SkuSettingsComponent,
    SingleSkuPriceSettingsComponent,
    SkuItemStockGridComponent,
    SkuFbaHistoryGridComponent,
    SkuMappingComponent,
    SkuMappingEditComponent,
    SyncHistoryComponent,
    FbmProductdetailsComponent,
    FbmSkudetailsComponent,
    FbmFinancialsDetailsComponent,    
    PriceBreakdownComponent,
  ],
})
export class DetailModule {}
